export enum PhoneType {
  Business = 'business',
  Mobile = 'mobile',
  Other = 'other',
  Fax = 'fax'
}
